import { render, staticRenderFns } from "./infoDetail.vue?vue&type=template&id=e3d82a1c&scoped=true&"
import script from "./infoDetail.vue?vue&type=script&lang=js&"
export * from "./infoDetail.vue?vue&type=script&lang=js&"
import style0 from "./infoDetail.vue?vue&type=style&index=0&id=e3d82a1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d82a1c",
  null
  
)

export default component.exports